<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Prepaid</a></li>
                    </ul>

                    <h3>Account Management</h3>

                    <h3 class="mt-6">Subscription Upgrade Cancelled</h3>

                    <div class="field">
                        <span>
                            Your subscription upgrade was cancelled. Please try again if want to make changes to your IsoEvolve subscription.
                        </span>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import PayfastPaymentsService from "@/service/PayfastPaymentsService";
import numeral from "numeral";
import SystemConfigService from "@/service/SystemConfigService";
import PaymentService from "@/service/PaymentService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    computed: {
        assistantLabel() {
            const map = {
                F: 'Free Plan',
                B: 'Basic Plan',
                N: 'Advanced Plan',
                P: 'Professional Plan',
                A: 'Automations',
                M: 'Managed Services'
            };
            return map[this.companyConfiguration.assistant] || 'Unknown';
        },
        assistantSeverity() {
            const severityMap = {
                F: 'info',
                B: 'success',
                N: 'warning',
                P: 'primary',
                A: 'help',
                M: 'danger'
            };
            return severityMap[this.companyConfiguration.assistant] || 'secondary';
        }
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            currency: "GBP",
            amount: 100,
            readyToPay: false,
            readyToGetPaymentDetails: false,
            payfastEndpoint: 'https://www.payfast.co.za/eng/process',
            paymentReference: this.$route.query.paymentReference ?? null,
            payfastFields: {
                merchantId: '',
                merchantKey: '',
                returnUrl: '',
                cancelUrl: '',
                notifyUrl: '',
                mPaymentId: '',
                amount: '',
                itemName: '',
                customStr1: '',
                customStr2: '',
                customStr3: '',
                signature: '',
            },
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

                console.log("[ProfileAccount][mounted] this.paymentReference = ", this.paymentReference);

                if ( (this.paymentReference != null) && (this.paymentReference !== "cancel") ) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Prepaid allocated. Reference = ' + this.paymentReference,
                        life: 3000
                    });

                    this.$router.replace({
                        path: this.$route.path,
                        query: {}
                    });

                } else if (this.paymentReference === "cancel") {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Transaction cancelled',
                        life: 3000
                    });

                    this.$router.replace({
                        path: this.$route.path,
                        query: {}
                    });

                } else {
                    this.paymentReference = null;
                }

                try {
                    const [companyConfigData, payfastServerUrlData] = await Promise.all([
                        CompanyService.getCompanyConfiguration(this.profile.companyId),
                        SystemConfigService.getPayfastServerUrl()
                    ]);

                    this.companyConfiguration = companyConfigData.data;
                    console.log("[ProfileAccount][mounted] companyConfigData.data = ", companyConfigData.data);

                    console.log("[ProfileAccount][mounted] this.companyConfiguration.region = ", this.companyConfiguration.region);

                    this.payfastEndpoint = payfastServerUrlData.data;
                    console.log("[ProfileAccount][mounted] this.payfastEndpoint = ", this.payfastEndpoint);

                    if (this.companyConfiguration.region === "ZA") {
                        this.currency = "ZAR";
                    } else if (this.companyConfiguration.region === "US") {
                        this.currency = "USD";
                    } else if (this.companyConfiguration.region === "CA") {
                        this.currency = "CAD";
                    } else if (this.companyConfiguration.region === "IN") {
                        this.currency = "INR";
                    } else {
                        this.currency = "GBP";
                    }

                    console.log("[ProfileAccount][mounted] this.currency = ", this.currency);

                    this.loading = false;
                    this.readyToGetPaymentDetails = true;
                    this.readyToPay = false;

                    console.log("[ProfileAccount][mounted] this.readyToGetPaymentDetails = ", this.readyToGetPaymentDetails);
                    console.log("[ProfileAccount][mounted] this.readyToPay = ", this.readyToPay);

                } catch (e) {
                    console.error("[ProfileAccount][mounted] Error fetching additional data = ", e);
                }

                // await this.refreshPaymentDetails();

            } catch (e) {
                console.error("[ProfileAccount][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return; // Exit early if getUser fails
            }
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        },
        processBuy() {
            console.log("[ProfileAccount][processBuy] this.selectedCountry = ", this.selectedCountry);
            console.log("[ProfileAccount][processBuy] this.selectedCountry.length = ", this.selectedCountry.length);

            this.selectedStripePriceId = "price_1SiZLgCURPtxakSUSorwzFMO";

            this.submitted = true;

            try {

                const customDataObj = {
                    siPlan: "B",
                };

                // Verify that all keys and values are strings
                const customDataObjAsStrings = Object.fromEntries(
                    Object.entries(customDataObj).map(([key, value]) => [String(key), String(value)])
                );

                var companyDto = {
                    email: this.profile.email,
                    companyId: this.profile.companyId,
                    customData: customDataObjAsStrings
                };

                console.log('[ProfileAccount][processBuy] companyDto = ', companyDto);

                PaymentService.createStripeCheckoutSessionExistingClientKitrin(
                    this.profile.companyId, this.selectedStripePriceId, companyDto)
                    .then(response => {
                        console.log("[ProfileAccount][processBuyStripe] Response = ", response);
                        console.log("[ProfileAccount][processBuyStripe] response.data = ", response.data);
                        console.log("[ProfileAccount][processBuyStripe] response.data.url = ", response.data.url);

                        window.top.location.href = response.data.url; // Redirect to Stripe Checkout
                    })
                    .catch(e => {
                        console.log("[ProfileAccount][processBuy] Error = ", e);
                    });

            } catch (e) {
                console.error('[ProfileAccount][processBuy] Error:', e);
            }

            this.submitted = false;
        },
        async getPayfastDetails() {
            await this.refreshPaymentDetails();
            this.readyToGetPaymentDetails = true;
            this.readyToPay = true;

            if (!this.readyToPay) return;
            if (!this.$refs.payfastForm) {
                console.error('Form not found in DOM at submit time.');
                return;
            }

            this.$refs.payfastForm.submit();

            console.log("[ProfileAccount][getPayfastDetails] this.readyToGetPaymentDetails = ", this.readyToGetPaymentDetails);
            console.log("[ProfileAccount][getPayfastDetails] this.readyToPay = ", this.readyToPay);

        },
        async refreshPaymentDetails() {
            try {
                console.log("[ProfileAccount][refreshPaymentDetails] Getting new details for amount = ", this.amount);

                this.loading = true;
                this.error = '';
                this.readyToPay = false;

                // hit backend to get new payment details for THIS invoice THIS amount
                const res = await PayfastPaymentsService.getPaymentDetailsWithAmount(
                    this.profile.companyId,
                    this.amount
                );

                this.payfastFields = {
                    merchantId:   res.data.merchantId,
                    merchantKey:  res.data.merchantKey,
                    returnUrl:    res.data.returnUrl,
                    cancelUrl:    res.data.cancelUrl,
                    notifyUrl:    res.data.notifyUrl,
                    mPaymentId:   res.data.mPaymentId,
                    amount:       res.data.amount,
                    itemName:     res.data.itemName,
                    customStr1:   res.data.customStr1,
                    customStr2:   res.data.customStr2,
                    customStr3:   res.data.customStr3,
                    signature:    res.data.signature,
                };

                console.log('[ProfileAccount][refreshPaymentDetails] payfastFields = ', this.payfastFields);

                this.readyToPay = true;
            } catch (e) {
                console.error('[ProfileAccount][refreshPaymentDetails] Error:', e);
                this.error = e?.message || 'Failed to load PayFast payment details.';
            } finally {
                this.loading = false;
                this.readyToPay = true;
            }
        },
        submitPayfast() {
            console.log('[ProfileAccount][submitPayfast] readyToPay =', this.readyToPay);
            console.log('[ProfileAccount][submitPayfast] payfastForm ref =', this.$refs.payfastForm);

            if (!this.readyToPay) return;
            if (!this.$refs.payfastForm) {
                console.error('Form not found in DOM at submit time.');
                return;
            }

            this.$refs.payfastForm.submit();
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
